var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconCallIncommingMissed = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_call_incomming_missed",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1584",
    "data-name": "Path 1584",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5244",
    "data-name": "Group 5244",
    transform: "translate(-1162.997 -1069.735)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1600",
    "data-name": "Path 1600",
    d: "M8.421,1.018,7.367,0,1.434,5.83V2.054H0v6.21H6.2V6.832H2.574Z",
    transform: "translate(1174.5 1073.735)",
    fill: "#ff4e4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1585",
    "data-name": "Path 1585",
    d: "M5.817,9.061a11.787,11.787,0,0,0,5.128,5.128l1.712-1.712a.774.774,0,0,1,.794-.187,8.876,8.876,0,0,0,2.778.444.78.78,0,0,1,.778.778v2.716a.78.78,0,0,1-.778.778A13.227,13.227,0,0,1,3,3.778.78.78,0,0,1,3.778,3H6.5a.78.78,0,0,1,.778.778,8.84,8.84,0,0,0,.444,2.778.781.781,0,0,1-.195.794Z",
    transform: "translate(1163.997 1072.497)",
    fill: "#ff4e4e"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconCallIncommingMissed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_call_incomming_missed.4d35e50661f4df05923b9c818933a3ed.svg";